<template>
  <modal
    name="bank-movement-view-modal"
    height="auto"
    class="md:m-6"
    adaptive
    scrollable
    @opened="opened"
    @closed="closed"
  >
    <b-loading
      v-model="loading"
      :is-full-page="false"
    />
    <div :key="movementId">
      <div>
        <bank-movement-info
          v-bind="$props"
          @close="hide()"
        />
      </div>
      <div>
        <comments
          v-bind="$props"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import Comments from './comments.vue';
import BankMovementInfo from './bank-movement-info.vue';

const NAVIGATION_KEYS = { ArrowLeft: -1, ArrowRight: 1 };
const EDITABLE_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];

export default {
  data() {
    return {
      active: this.isModalActive,
    };
  },
  components: {
    Comments,
    BankMovementInfo,
  },
  computed: {
    loading() {
      return this.$store.state.movements.loadingMovement ||
             this.$store.state.movements.loadingComments ||
             this.$store.state.users.loadingAuthorizerUser;
    },
  },
  props: {
    isModalActive: {
      type: Boolean,
      default: false,
    },
    movementId: {
      type: Number,
      default: null,
    },
    flipButtonsStyle: {
      type: Boolean,
      default: false,
    },
    entityId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    show() {
      this.$modal.show('bank-movement-view-modal');
    },
    hide() {
      this.$modal.hide('bank-movement-view-modal');
    },
    opened() {
      this.addKeyListener();
      this.$emit('opened');
    },
    closed() {
      this.removeKeyListener();
      this.$emit('closed');
    },
    addKeyListener() {
      window.addEventListener('keydown', this.handleKeydown);
    },
    removeKeyListener() {
      window.removeEventListener('keydown', this.handleKeydown);
    },
    handleKeydown(event) {
      const step = NAVIGATION_KEYS[event.key];
      if (!step || this.isEditing(event.target) || this.isOtherModalOpen()) return;

      event.preventDefault();
      this.$emit('navigate', step);
    },
    isEditing(target) {
      return EDITABLE_TAGS.includes(target.tagName) || target.isContentEditable;
    },
    isOtherModalOpen() {
      return !!document.querySelector('.vm--overlay:not([data-modal="bank-movement-view-modal"])');
    },
  },
  beforeDestroy() {
    this.removeKeyListener();
  },
};
</script>>
<style>
  .vm--overlay[data-modal="bank-movement-view-modal"] + .vm--modal {
    height: auto !important;
  }
</style>
